// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-dialog-absent-content-language {
  display: block;
}
.fi-document-dialog-absent-content-language .dialog-header {
  font-size: 1.3em;
  font-weight: bold;
  margin-bottom: 0.5em;
}
.fi-document-dialog-absent-content-language .dialog-select {
  margin-top: 1.5em;
  line-height: 2.2em;
}`, "",{"version":3,"sources":["webpack://./Source/app/document/dialog-absent-content-language/dialog-absent-content-language.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;AACR;AAEI;EACI,iBAAA;EACA,kBAAA;AAAR","sourcesContent":[".fi-document-dialog-absent-content-language {\r\n    display: block;\r\n\r\n    .dialog-header {\r\n        font-size: 1.3em;\r\n        font-weight: bold;\r\n        margin-bottom: 0.5em;\r\n    }\r\n\r\n    .dialog-select {\r\n        margin-top: 1.5em;\r\n        line-height: 2.2em;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
